module.exports = __webpack_public_path__ + "img/revert-icon.8a60fb70.svg";